@if (format === "column") {
    <div class="wk-card-t1__column__head">
        <div #cardT1ColumnName class="wk-card-t1__column__head-name">
            {{ _cardData | cardTitle }}
            @if (!tooltipDisabled()) {
                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="indicator"
                            position="bottom"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="`#${divId} .wk-card-t1__column__head-name`"
                        >
                            {{ _cardData | cardTitle }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            }
        </div>
        @if (_cardData.isVIP || _cardData.originalId) {
            <div class="wk-card-t1__column__head-tags">
                @if (_cardData.isVIP) {
                    <tag-pds3 type="dark" class="wk-card-t1__column__head-tags--vip">VIP</tag-pds3>
                }
                @if (_cardData.originalId) {
                    <div class="wk-card-t1__column__head-tags--duplicate">
                        <tag-pds3 type="dark">{{ "Dashboard.Dup" | translate }}</tag-pds3>
                    </div>
                    @if (isHovered()) {
                        <portal-pds3 elementId="wk-app__root">
                            <tooltip-pds3
                                mode="indicator"
                                position="bottom"
                                [openDelay]="400"
                                [closeDelay]="50"
                                [targetSelector]="`#${divId} .wk-card-t1__column__head-tags--duplicate`"
                            >
                                {{ "Dashboard.Dup_Tooltip" | translate }}
                            </tooltip-pds3>
                        </portal-pds3>
                    }
                }
            </div>
        }
        <div class="wk-card-t1__column__head-count">
            <icon-pds3 name="wk-icon-user2" />
            <div>{{ clientFileCount }}</div>
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="left"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId} .wk-card-t1__column__head-count`"
                    >
                        {{ "Tooltips.NumberOfReturnsInCard" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
    </div>
    <div class="wk-card-t1__column__body">
        <div class="wk-card-t1__column__body-left">
            <div class="wk-card-t1__column__body__complexity">
                @if (complexity()) {
                    @let complexityTextValue = complexity() | wkTranslate;
                    <i class="wk-card-t1__icon wk-card-t1__icon--tags" aria-hidden="true"></i>
                    <div #complexityText class="wk-card-t1__column__body__complexity-text">{{ complexityTextValue }}</div>
                    @if (tagNames && tagNames.length > 0) {
                        @if (isHovered()) {
                            <portal-pds3 elementId="wk-app__root">
                                <tooltip-pds3
                                    mode="description"
                                    position="top"
                                    [openDelay]="400"
                                    [closeDelay]="50"
                                    [targetSelector]="`#${divId} .wk-card-t1__icon--tags`"
                                    class="wk-card-t1__column__body__complexity-tooltip"
                                >
                                    @for (tag of tagNames; track $index) {
                                        <div>{{ tag }}</div>
                                    }
                                </tooltip-pds3>
                            </portal-pds3>
                        }
                    }
                    @if (showComplexityTooltip()) {
                        @if (isHovered()) {
                            <portal-pds3 elementId="wk-app__root">
                                <tooltip-pds3
                                    mode="indicator"
                                    position="top"
                                    [openDelay]="400"
                                    [closeDelay]="50"
                                    [targetSelector]="`#${divId} .wk-card-t1__column__body__complexity-text`"
                                    class="wk-card-t1__column__body__complexity-text-tooltip"
                                >
                                    {{ complexityTextValue }}
                                </tooltip-pds3>
                            </portal-pds3>
                        }
                    }
                }
            </div>
            <div class="wk-card-t1__column__body-date">
                <i
                    class="wk-card-t1__icon wk-card-t1__icon--calendar"
                    [class.wk-card-t1__icon--calendar--warning]="
                        cardViewService.currentViewType !== 'completed' && isDeadlineWarning && !isDeadlineAlert
                    "
                    [class.wk-card-t1__icon--calendar--alert]="
                        cardViewService.currentViewType !== 'completed' && isDeadlineAlert && deadlineDate !== null
                    "
                ></i>
                <div
                    class="wk-card-t1__column__body-deadline"
                    [class.wk-card-t1__column__body-deadline--empty]="deadlineDate === null || (!isDeadlineWarning && !isDeadlineAlert)"
                    [class.wk-card-t1__column__body-deadline--warning]="
                        cardViewService.currentViewType !== 'completed' && deadlineDate !== null && isDeadlineWarning && !isDeadlineAlert
                    "
                    [class.wk-card-t1__column__body-deadline--alert]="
                        cardViewService.currentViewType !== 'completed' && deadlineDate !== null && isDeadlineAlert
                    "
                >
                    @if (deadlineDate !== null) {
                        {{ deadlineDate }}
                    } @else {
                        {{ "General.NotDefinedFem" | translate }}
                    }
                </div>
                @if (isHovered()) {
                    @let tooltip = tooltipText();
                    @if (tooltip !== "") {
                        <portal-pds3 elementId="wk-app__root">
                            <tooltip-pds3
                                mode="description"
                                position="top"
                                [openDelay]="400"
                                [closeDelay]="50"
                                [targetSelector]="`#${divId} .wk-card-t1__column__body-date .wk-card-t1__icon--calendar`"
                            >
                                {{ tooltip }}
                            </tooltip-pds3>
                        </portal-pds3>
                    }
                }
            </div>
        </div>
        <div class="wk-card-t1__column__body-gravatar" [class.wk-card-t1--danger]="_cardData.isAlertDueDate">
            {{ assignedUser() | UserInitial: "N/A" }}
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="indicator"
                        position="left"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId} .wk-card-t1__column__body-gravatar`"
                    >
                        {{ assignedUser() | UserName: "N/A" }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
    </div>
    <div class="wk-card-t1__column__footer">
        <div class="wk-card-t1__column__footer-averagedays">
            <i class="wk-card-t1__icon wk-card-t1__icon--stopwatch"></i>
            <span>{{ daysSinceReady }} {{ "Dashboard.AverageDays" | translate }}</span>
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId} .wk-card-t1__column__footer-averagedays .wk-card-t1__icon`"
                    >
                        {{ "Tooltips.NumberOfDaysSinceStart" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>

        <div
            class="wk-card-t1__column__footer-dayssinceinstep"
            [class.wk-card-t1__column__footer-dayssinceinstep--danger]="cardViewService.currentViewType !== 'completed' && isStepAlert"
            [class.wk-card-t1__column__footer-dayssinceinstep--warning]="
                cardViewService.currentViewType !== 'completed' && !isStepAlert && isStepWarning
            "
            [class.wk-card-t1__column__footer-dayssinceinstep--quiet]="quietDaysFromNow > 0"
        >
            <i class="wk-card-t1__icon wk-card-t1__icon--clock"></i>
            <span class="wk-card__footer-days">
                {{ daysSinceInStep }}
                {{ "Dashboard.AverageDays" | translate }}
            </span>
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3
                        mode="description"
                        position="top"
                        [openDelay]="400"
                        [closeDelay]="50"
                        [targetSelector]="`#${divId} .wk-card-t1__column__footer-dayssinceinstep .wk-card-t1__icon`"
                    >
                        {{ "Tooltips.NumberOfDaysSinceColumn" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        </div>
    </div>
} @else if (format === "grid") {
    @if (cardViewService.currentViewType === "notStarted") {
        <div class="col-md-3 wk-card-t1__grid-name-column">
            <span class="wk-card-t1__taxpayer-count">{{ clientFileCount }}</span>
            @if (_cardData.isVIP) {
                <div class="wk-card-t1__tags">
                    <tag-pds3 type="dark" color="info">VIP</tag-pds3>
                </div>
            }
            @if (documentReceivedLate) {
                <i class="fa fa-exclamation-triangle warning wk-card-t1__icon--alert"></i>

                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="description"
                            position="right"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="`#${divId} .wk-card-t1__grid-name-column .wk-card-t1__icon--alert`"
                        >
                            {{ "NotStarted.DocumentsReceivedLate" | translate }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            }
            {{ _cardData | cardTitle }}
        </div>
        <div class="col-md-2">
            @if (_cardData.return.type) {
                <span>{{ "Board." + _cardData.return.type | translate }}</span>
            }
        </div>
        @if (showLastYearReceivedDateColumn) {
            <div class="col-md-5">{{ lastYearDocumentsReceivedDateByLanguage }}</div>
        }
        <div class="col-md-2">{{ complexityTextLabel() | wkTranslate }}</div>
        @if (showPartnerManagerTooltips) {
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3 mode="description" position="top" [openDelay]="400" [closeDelay]="50" [targetSelector]="'#' + divId">
                        {{ "Tooltips.DisabledPartnerManager" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        }
    } @else if (cardViewService.currentViewType === "completed") {
        <div class="col-md-3 wk-card-t1__grid-name-column">
            <span class="wk-card-t1__taxpayer-count">{{ clientFileCount }}</span>
            @if (_cardData.isVIP) {
                <div class="wk-card-t1__tags">
                    <tag-pds3 type="dark" color="info">VIP</tag-pds3>
                </div>
            }
            @if (isEFileStatusAlert && cardViewService.currentViewType === "completed") {
                <i class="fa fa-exclamation-triangle warning wk-card-t1__icon--alert"></i>
                @if (isHovered()) {
                    <portal-pds3 elementId="wk-app__root">
                        <tooltip-pds3
                            mode="description"
                            position="right"
                            [openDelay]="400"
                            [closeDelay]="50"
                            [targetSelector]="`#${divId} .wk-card-t1__grid-name-column .wk-card-t1__icon--alert`"
                        >
                            {{ "CompletedView.TaxReturnNotCompletedAccordingToEFILE" | translate }}
                        </tooltip-pds3>
                    </portal-pds3>
                }
            }
            {{ _cardData | cardTitle }}
        </div>
        <div class="col-md-2">
            @if (_cardData.return.type) {
                <span>{{ "Board." + _cardData.return.type | translate }}</span>
            }
        </div>

        <div class="col-md-2">{{ thisYearCompletionDateByLanguage }}</div>
        <div class="col-md-2">{{ lastYearCompletedDateByLanguage }}</div>
        <div class="col-md-1 truncate">{{ complexityTextLabel() | wkTranslate }}</div>
        <div class="col-md-1">{{ daysSinceReady }} {{ "CardModal.Days" | translate }}</div>
        @if (showPartnerManagerTooltips) {
            @if (isHovered()) {
                <portal-pds3 elementId="wk-app__root">
                    <tooltip-pds3 mode="description" position="top" [openDelay]="400" [closeDelay]="50" [targetSelector]="'#' + divId">
                        {{ "Tooltips.DisabledPartnerManager" | translate }}
                    </tooltip-pds3>
                </portal-pds3>
            }
        }
    }
}
